import router from './router'
import store from './store'
import { Toast } from 'vant'
import { getToken } from '@/utils/auth' // get token from cookie
import { pathMatcher } from '@/utils/index'

const whiteList = ['/login', '/registry', '/', '/index', '/category', '/detail/**', '/diamondGoodsList/**', '/search/**', '/order/coupon', '/notice/list', '/notice/detail/**', '/ccb/entry', '/ccb/entry**'] // 白名单

router.beforeEach(async(to, from, next) => {
  // 设置标题
  const brandId = store.getters.brandId
  const brandName = store.getters.brandName
  let title = to.meta.title || '天津益生堂生活馆'

  // 如果有品牌名称，所有页面都显示品牌名称+商城
  if (brandName && brandName.trim()) {
    title = `${brandName}商城`
  } else if (brandId && brandId !== '0') {
    // 如果没有品牌名称但有品牌ID，显示商城
    title = `商城`
  } else {
    // 没有品牌信息时使用原标题
    title = to.meta.title || '天津益生堂生活馆'
  }

  document.title = title

  // 根据token判断用户是否登录
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // 如果已经登录了，而去的又是login页就重定向到首页
      next({ path: '/' })
    } else {
      const hasUserInfo = store.getters.id
      if (hasUserInfo) {
        next()
      } else {
        // 如果用户刷新了浏览器，那么需要重新请求基本信息塞到vuex中进行状态管理
        try {
          await store.dispatch('user/getInfo')
          next()
        } catch (error) {
          if (pathMatcher(whiteList, to.path)) {
            next()
          } else {
            // 清空token重新去登录
            // await store.dispatch('user/resetToken')
            // next(`/login?redirect=${encodeURIComponent(location.href)}`)
          }
        }
      }
    }
  } else {
    if (pathMatcher(whiteList, to.path)) {
      console.log(to.path)
      next()
    } else {
      // 1. 判断是否在建行环境（通过缓存、User-Agent 或 URL 携带的建行参数）
      const ccbEnv = sessionStorage.getItem('ccbEnv')
      const ua = (navigator.userAgent || '').toLowerCase()
      const search = window.location.search || ''
      const isCcbParam = to.query.platform === 'ccblife' || !!to.query.ccbParamSJ ||
                         search.includes('platform=ccblife') || search.includes('ccbParamSJ')
      const isCcbEnv = ccbEnv === 'CCB_LIFE' || ccbEnv === 'CCB_APP' ||
                       ua.includes('cloudmercwebview') || ua.includes('ccblife') ||
                       ua.includes('ccb_bank') || isCcbParam

      if (isCcbEnv) {
        // 2. 如果是建行环境且未登录，禁止去普通登录页，重定向去建行静默登录中转入口
        // 必须把原本 URL 上的建行参数（ccbParamSJ, platform, channel 等）及原页面完整路径透传给 /ccb/entry
        const ccbQuery = { ...to.query }
        if (!ccbQuery.ccbParamSJ && search.includes('ccbParamSJ')) {
          try {
            const sp = new URLSearchParams(search)
            if (sp.get('ccbParamSJ')) ccbQuery.ccbParamSJ = sp.get('ccbParamSJ')
            if (sp.get('platform')) ccbQuery.platform = sp.get('platform')
            if (sp.get('channel')) ccbQuery.channel = sp.get('channel')
          } catch (e) { void e }
        }
        next({
          path: '/ccb/entry',
          query: {
            ...ccbQuery,
            redirect: to.fullPath
          }
        })
      } else {
        // 3. 普通浏览器环境去常规登录页
        next(`/login?redirect=${encodeURIComponent(location.href)}`)
      }
    }
  }
})

router.afterEach(() => {
  Toast.clear()
})
